<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange" style="width: 150px;">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-radio-group v-model="jxPosition" @change="jxClick" size="mini">
                    <el-radio-button label="1">本月</el-radio-button>
                    <el-radio-button label="2">上月</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 6rem)" ref="table" :data="hairStaffs" show-header style="width: 100%" @row-click="openHairHead" show-summary :summary-method="getSummaries">
            <el-table-column prop="staffname" align="center" label="员工姓名"></el-table-column>
            <el-table-column prop="ldjx" align="center" label="绩效">
                <template slot-scope="scope">
                    {{scope.row.ldjx.toFixed(1)}}
                </template>
            </el-table-column>
            <el-table-column prop="hlnumber" align="center" width="100" label="负责客量">
                <template slot-scope="scope">
                    {{scope.row.hlnumber}}({{percentgae(scope.row.greedlv)}})
                </template>
            </el-table-column>
            <!--<el-table-column prop="avgday" align="center" label="红灯/黄灯">
                <template slot-scope="scope">
                    {{scope.row.red}}/{{scope.row.hd}}
                </template>
            </el-table-column>-->
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                jxPosition:1,
                brands:[],
                hairStaffs:[],
                storeid:localStorage.getItem("storeid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
            }
        },
        created: function () {
            this.getStoreInfoByStructsOpen();
            this.getHairHeadStaffByStore();
        },
        updated () {
            this.$nextTick(() => {
                this.$refs['table'].doLayout();
            });  
        },
        methods: {
            percentgae(number){
                return Math.round(number*100)+"%"
            },
            getSummaries(param){
                const {columns, data} = param;
                const sums = [];
                let headnumber=0;
                let greednumber=0;
                let rednumber=0;
                let ynumber=0;
                for(let val of data){
                    headnumber=headnumber+val.hlnumber;
                    rednumber=rednumber+val.red;
                    ynumber=ynumber+val.hd;
                }
                greednumber=headnumber-rednumber-ynumber;
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    else if(index==1){
                        sums[index] = '绿灯'+greednumber;
                    }
                    else if(index==2){
                        sums[index] = headnumber+"("+this.$percentgae(greednumber/headnumber)+")";
                    }
                    else if(index==3){
                        sums[index] = rednumber+"/"+ynumber;
                    }
                });
                return sums;
            },
            jxClick(e){
                if(e==1){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(e==2){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.fromdate=days+"-01";
                    this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                }
                this.getHairHeadStaffByStore();
            },
            openHairHead(row){
                localStorage.setItem("querystaffid",row.staffid);
                this.$router.push({path:"/hairstaff",query:{
                    staffid:row.staffid,
                }});
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getHairHeadStaffByStore();
            },
            getHairHeadStaffByStore(){
                this.$post("hairmanager/getStaffJx",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        this.hairStaffs=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/staffjx.vue